export const PermissionQueries: Readonly<{
  GetAdminPermissionsForUser: 'GetAdminPermissionsForUser';
}> = {
  GetAdminPermissionsForUser: 'GetAdminPermissionsForUser',
};

export type PermissionQueryTypes =
  typeof PermissionQueries.GetAdminPermissionsForUser;
